



























































import {
  getComponent,
  getComponentByInspectUid,
  genPostReq
} from "@/services/checklist.service";

import TransferInspectModal from "@/components/TransferInspectModal.vue";
import ImportChecklistModal from "@/components/ImportChecklistModal.vue";
import draggable from "vuedraggable";
import Rotorblade from "@/components/rotorblades/Rotorblade.vue"
import { EventBus } from '@/event-bus.js';

export default {
  data() {
    return {
      na1: false,
      initLoaded: true,
      snackbar: false,
      snackbar_text: "",
      sort_items: [{ text: "hallo"}, {text: "welt"}]
    };
  },
  components: {
     draggable,
     Rotorblade
  },

  mounted() {
    this.$store.state.headerTitle = "Rotorblätter"
    this.$store.state.cl_uid = this.$route.params.uid;
    EventBus.$on('show_toast', this.show_snackbar);

  },
  computed: {


  },
  methods: {
    itemClicked: function () {
      console.log("oh ja")
    },
    show_snackbar: function (d) {
      console.log("show_snackbar", d)
      this.snackbar = true
      this.snackbar_text = d.text
    }
  }
};
